import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface TaxDotComDocsSvcLogListGridActionCellRendererParams extends ICellRendererParams {
    viewDetails: (params: TaxDotComDocsSvcLogListGridActionCellRendererParams) => void;
}

@Component({
    selector: 'taxdotcom-docs-svc-log-grid-action-cell',
    template:
        `@if (taxDotComDocsSvcSummaryLog) {
  <button type="button"
    class="ace-btn btn-primary has-icon grid-action-button"
    (click)="params.viewDetails(params)"
    helpTooltip
    helpContentId="app.view"
    position="bottom">
    <i class="fa fa-pencil"></i>
  </button>
}`,
    standalone: false
})
export class TaxDotComDocsSvcLogListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: TaxDotComDocsSvcLogListGridActionCellRendererParams;
    taxDotComDocsSvcSummaryLog: Core.TaxDotComDocsSvcSummaryLogModel;

    agInit(params: TaxDotComDocsSvcLogListGridActionCellRendererParams): void {
        this.params = params;
        this.taxDotComDocsSvcSummaryLog = params.data as Core.TaxDotComDocsSvcSummaryLogModel;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
